export const shouldUpdatePanelSize = (name) => [
  'board_length',
  'board_width',
  'array_x_qty',
  'array_y_qty',
  'tab_rout',
  'scoring',
].includes(name);

export const updatePanelSize = (state) => {
  const {
    board_length,
    board_width,
    array_x_qty,
    array_y_qty,
    tab_rout,
    scoring,
  } = state.parameters;

  if (
    parseFloat(board_length) &&
    parseFloat(board_width) &&
    parseInt(array_x_qty, 10) &&
    parseInt(array_y_qty, 10)
  ) {
    const arrayUp = parseInt(array_x_qty, 10) * parseInt(array_y_qty, 10);
    const arrayX = parseInt(array_x_qty, 10) * parseFloat(board_length);
    const arrayY = parseInt(array_y_qty, 10) * parseFloat(board_width);
    let panelSizeX = arrayX;
    let panelSizeY = arrayY;

    if (scoring === '1') {
      panelSizeX += 0.5;
      panelSizeY += 0.5;
    }

    if (tab_rout === '1') {
      panelSizeX += 0.1 * (parseInt(array_x_qty, 10) - 1);
      panelSizeY += 0.1 * (parseInt(array_y_qty, 10) - 1);

      if (!scoring) {
        panelSizeX += 0.5;
        panelSizeY += 0.5;
      }
    }

    state.parameters.array_up = $.number(arrayUp, 0);
    state.parameters.array_x = $.number(arrayX, 2);
    state.parameters.array_y = $.number(arrayY, 2);
    state.parameters.panel_size_x = $.number(panelSizeX, 2);
    state.parameters.panel_size_y = $.number(panelSizeY, 2);
  } else {
    state.parameters.array_up = $.number(0, 0);
    state.parameters.array_x = $.number(0, 2);
    state.parameters.array_y = $.number(0, 2);
    state.parameters.panel_size_x = $.number(0, 2);
    state.parameters.panel_size_y = $.number(0, 2);
  }
};
